// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"c5b0f5e2","513":"7c103768","703":"ee78c2dc","787":"0554d445"}[chunkId] + ".chunk.js";
};